import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { IconButton } from "@material-ui/core";
import SettingsIcon from "@material-ui/icons/SettingsOutlined";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Tooltip from "../../common/StyledToolTip";
import styles from "../headerStyles";
import Notifications from "./Notifications";
import NewShipmentsFeedbackPanel from "../../modules/IBPlanning/RoutesView/NewShipmentsFeedbackPanel";
import HelpMenu from "../../common/HelpMenu";
import WatchTutorial from "../../InAppTutorial/WatchTutorial";
import TerminalMenu from "./../common/TerminalMenu";
import PublishProgressLoader from "./components/PublishProgressLoader";

class RightNavigationMenu extends React.Component {
  constructor(props) {
    super(props);
  }

  openDynamicRoutingModal = () => {
    if (this.disbaleDynamicRouting || this.props.isOptimizationRunning) {
      return false;
    }
    this.props.shouldDialogOpen("dynamicRouting");
  };

  getOptimizationTooltip = (
    enableDynamicRouting,
    isDataRefreshProgress,
    selectedRouteCount
  ) => {
    if (!enableDynamicRouting) {
      return "Route optimization is disabled";
    }

    if (isDataRefreshProgress) {
      return "Data refresh is in progress";
    }

    if (selectedRouteCount) {
      return "Create most efficient routes without any zipcode boundaries";
    } else {
      return "Select at least one route to run dynamic routing";
    }
  };
  getPublishTooltipTitle = () => {
    const { isDefaultScenario, isPublishInProgress } = this.props;
    if (isPublishInProgress) return 'Route publish is in progress';
    return isDefaultScenario
      ? 'Publish Routes'
      : 'Can only publish routes from default scenario';
  };
  
  getPublishIcon = () => {
    const { isDefaultScenario, isPublishInProgress, classes } = this.props;
    if (isPublishInProgress) return <PublishProgressLoader />;
    
    const iconClass = isDefaultScenario
      ? classes.publishIconStyle
      : classes.disabledPublishIcon;
  
    return <i className={`${iconClass} icon-icon_upload`} />;
  };
  
  handlePlanPublish = () => {
    const { isDefaultScenario, isPublishInProgress, shouldDialogOpen, closeMenu } = this.props;
    if (isPublishInProgress) return;
    shouldDialogOpen('publish', Boolean(isDefaultScenario));
    closeMenu();
  };

  render() {
    const {
      isOptimizationRunning,
      isDataRefreshProgress,
      currentTerminalId,
      selectedRouteCount,
      enableDynamicRouting,
      classes,
      handleAddClick,
      showNotificationHeaderIcon,
      userData,
      onTerminalChange
    } = this.props;
    this.disbaleDynamicRouting =
      !(enableDynamicRouting && selectedRouteCount) || isDataRefreshProgress;
    return (
      <div
        className={classes.mainMenuStyle}
      >
        <div
          className={`${classes.optymizeBtnContainer} ${classes.headerIconStyles}`}
        >
          <Tooltip
            title={this.getOptimizationTooltip(
              enableDynamicRouting,
              isDataRefreshProgress,
              selectedRouteCount
            )}
          >
            <div
              className={
                this.disbaleDynamicRouting ? classes.disabledCursor : ""
              }
            >
                <Button
                  onClick={this.openDynamicRoutingModal}
                  variant="contained"
                  color="primary"
                  size="small"
                  disabled={this.disbaleDynamicRouting}
                  classes={{
                    root: classes.optymizeButtonStyle,
                    disabled: classes.disabledOptymizeBtn
                  }}
                  data-automationid="optimize-button">
                  {isOptimizationRunning ? (
                    <CircularProgress size={16} color="inherit" />
                  ) : (
                    'Route Optymizer'
                  )}
                </Button> 
            </div>
          </Tooltip>
          <WatchTutorial
            componentId="RouteOptymizer"
            classes={{
              headerIconStyles: classes.optimyzerWatchTutorial,
            }}
          />        
        </div>
        <HelpMenu 
          closeMenu = {this.props.closeMenu}
        />
        <TerminalMenu 
          currentTerminalId={currentTerminalId} 
          userData={userData}
          onChange={onTerminalChange}
          />
        <Tooltip title={this.getPublishTooltipTitle()}>
          <div
            className={`${classes.publishIconContainer} ${classes.headerIconStyles}`}
            onClick={this.handlePlanPublish}
            data-dd-action-name={"publish-route"}
            data-automationid="publish-routes">
            {this.getPublishIcon()}
          </div>
        </Tooltip>
        <div
          className={`${classes.muiIconContainer} ${classes.headerIconStyles}`}
        >
          <IconButton
            color="inherit"
            className={classes.muiIconButtonStyle}
            onClick={(e) => {
              this.props.openSettings(e, "/settings");
              this.props.closeMenu();
            }}
            data-automationid="settings-icon"
          >
            <Tooltip title="Application Settings">
              <SettingsIcon />
            </Tooltip>
          </IconButton>
        </div>
        {showNotificationHeaderIcon && (
          <Notifications //TODO : Reuse this component for showing driver msgs in dispatch module by just passing a different component as children prop.
            toggleNotificationPanel={this.props.toggleNotificationPanel}
            showNotificationPanel={this.props.showNotificationPanel}
            showNewNotification={this.props.showNewShipmentsNotification}
            unreadCount={this.props.unreadCount}
          >
            <NewShipmentsFeedbackPanel
              handleAddClick={handleAddClick}
              hideCloseAction
              hidePanelShadow
            />
          </Notifications>
        )}
        {/* <div className={`${classes.muiIconContainer} ${classes.headerIconStyles}`}>
                                <Tooltip title="Notifications">
                                    <IconButton color="inherit" className={classes.muiIconButtonStyle}>
                                        <NotificationsIcon />
                                    </IconButton>
                                </Tooltip>
                            </div> */}
      </div>
    );
  }
}

export default withStyles(styles)(RightNavigationMenu);
